module.exports = __webpack_public_path__ + "img/tgScout.e438f578.png";